export default __webpack_public_path__ + "static/media/google-play-badge.9ad16835.png";